import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-12 col-sm-6 text-end" }
const _hoisted_6 = { class: "d-inline-flex flex-wrap gap-3 justify-content-end" }
const _hoisted_7 = { class: "default-table-area style-two default-table-width" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table align-middle" }
const _hoisted_10 = { class: "text-body text-right" }
const _hoisted_11 = { class: "text-body" }
const _hoisted_12 = ["innerHTML", "title"]
const _hoisted_13 = { class: "text-body text-center" }
const _hoisted_14 = { class: "text-body text-right" }
const _hoisted_15 = { class: "text-body" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  id: "mdlConfiguration",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlConfigurationLabel",
  "aria-hidden": "true",
  size: "large"
}
const _hoisted_19 = { class: "modal-dialog modal-xl" }
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = { class: "modal-body" }
const _hoisted_22 = { class: "default-table-area style-two default-table-width" }
const _hoisted_23 = { class: "table-responsive" }
const _hoisted_24 = { class: "table align-middle" }
const _hoisted_25 = { class: "text-body" }
const _hoisted_26 = { class: "text-body" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "p-4 pt-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_RouterLink, {
                    to: `/play-type/create/${_ctx.idPlay}`
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                      }, [
                        _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                          _createElementVNode("span", null, "Agregar Acción")
                        ])
                      ], -1 /* HOISTED */)
                    ])),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["to"]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.configurationPlayModal())),
                    class: "btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                      _createElementVNode("span", null, "Agregar del Archivo")
                    ], -1 /* HOISTED */)
                  ])),
                  _createVNode(_component_RouterLink, { to: `/plays` }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                      }, [
                        _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                          _createElementVNode("span", null, "Regresar")
                        ])
                      ], -1 /* HOISTED */)
                    ])),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Orden"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Tipo"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Detalle"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Tipo de Pregunta"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Nro. Opciones"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode("asignación")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Opciones")
                ])
              ], -1 /* HOISTED */)),
              (_ctx.items.length)
                ? (_openBlock(), _createBlock(_component_draggable, {
                    key: 0,
                    modelValue: _ctx.items,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.items) = $event)),
                    "item-key": "id",
                    tag: "tbody",
                    handle: ".drag-handle",
                    animation: 200,
                    onEnd: _ctx.updateOrderItems
                  }, {
                    item: _withCtx(({ element: item }) => [
                      (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _cache[8] || (_cache[8] = _createElementVNode("td", { class: "text-body text-right drag-handle" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary cursor-move" }, "drag_indicator")
                        ], -1 /* HOISTED */)),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(item.order), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(item.playType), 1 /* TEXT */),
                        _createElementVNode("td", {
                          innerHTML: _ctx.limitHtmlContent(item.description),
                          title: _ctx.stripHtmlAndLimit(item.description)
                        }, null, 8 /* PROPS */, _hoisted_12),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(item.questionType ?? "-"), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(item.totalOptions ?? "-"), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(item.updatedAtDateTimeString ?? "-"), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_16, [
                          _createVNode(_component_RouterLink, {
                            to: `/play-type/${
                        item.playTypeId == _ctx.PLAY_TYPES.QUIZ
                          ? 'question'
                          : 'content'
                      }/edit/${item.id}`
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " edit ", -1 /* HOISTED */)
                            ])),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                          _createElementVNode("button", {
                            class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                            onClick: ($event: any) => (_ctx.removedPlay(item.playTypeId, item.id))
                          }, _cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "delete", -1 /* HOISTED */)
                          ]), 8 /* PROPS */, _hoisted_17)
                        ])
                      ]))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue", "onEnd"]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "mdlConfigurationLabel"
            }, " Repositorio de Jugadas "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("table", _hoisted_24, [
                  _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { scope: "col" }, "#"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Nombre de Jugada"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Nro. Acciones"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, [
                        _createTextVNode(" Creado"),
                        _createElementVNode("br"),
                        _createTextVNode(" por ")
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, [
                        _createTextVNode(" Fecha "),
                        _createElementVNode("br"),
                        _createTextVNode("creación ")
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Opciones")
                    ])
                  ], -1 /* HOISTED */)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.repository, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(index + 1), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.playName), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.items.length), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(item.createdBy), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(item.createdAtDateTimeString), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("button", {
                              class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                              onClick: ($event: any) => (_ctx.playActionsModal(item.id))
                            }, [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary ps-2" }, " settings ", -1 /* HOISTED */)
                            ]))], 8 /* PROPS */, _hoisted_29),
                            _createElementVNode("button", {
                              class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                              onClick: ($event: any) => (_ctx.assignPlay(item.id))
                            }, [...(_cache[11] || (_cache[11] = [
                              _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " add ", -1 /* HOISTED */)
                            ]))], 8 /* PROPS */, _hoisted_30)
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_Pagination, {
                  currentPage: _ctx.currentPage,
                  pageSize: _ctx.pageSize,
                  totalItems: _ctx.totalItems,
                  "onUpdate:page": _ctx.fetchPage
                }, null, 8 /* PROPS */, ["currentPage", "pageSize", "totalItems", "onUpdate:page"])
              ])
            ])
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              "data-bs-dismiss": "modal"
            }, " Cerrar ")
          ], -1 /* HOISTED */))
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}